/**
 * The adapter protocols whose offset matrices address ABSOLUTE byte offsets
 * rather than per-key register addresses.
 *
 * One definition, imported by every screen that needs it. It previously existed
 * three times — twice derived from the generated enum, once hand-written as
 * `new Set(["LN1", "RVU", "CGA", "LOBBYVISION"])` — and the screens that use it
 * decide whether per-key overlap detection applies. Three copies of a
 * membership test that gates a correctness behaviour is three chances to
 * disagree, and they already had: the bank matrix and the adapter matrix
 * reached different verdicts about the same keys.
 *
 * Derived from the generated `AdapterProtocol` enum by reverse lookup, never
 * hand-written, so a protocol added to the schema cannot silently fall out of
 * the set — the same defence `ROUTABLE_PROTOCOLS` uses in channelRouting.ts.
 *
 * NOT the same as `ROUTABLE_PROTOCOLS`: that one answers a routing question and
 * is deliberately a different membership (it omits LN1/RVU and includes
 * LobbyVision2).
 */
import { AdapterProtocol } from "../flatbuffers/generated/archive/adapter-protocol";

export const LN1_OFFSET_PROTOCOLS: ReadonlySet<string> = new Set<string>([
  AdapterProtocol[AdapterProtocol.LN1],
  AdapterProtocol[AdapterProtocol.RVU],
  AdapterProtocol[AdapterProtocol.CGA],
  AdapterProtocol[AdapterProtocol.LOBBYVISION],
]);

/** True when this adapter's matrix cells are absolute byte offsets. */
export function usesAbsoluteOffsets(protocolType: string | undefined | null): boolean {
  return LN1_OFFSET_PROTOCOLS.has((protocolType || "").toUpperCase());
}
